import { useEffect, useState } from 'react';
import { Config } from '../features/common/Common.types';

export function useConfiguration() {
  const [config, setConfig] = useState<Config | null>(null);
  const [isHavingSetupErr, setIsHavingSetupErr] = useState(false);

  useEffect(() => {
    const getConfigFile = async () => {
      try {
        const configFileName =
          process.env.NODE_ENV === 'development'
            ? 'config.local.json'
            : 'config.json';
        const response = await fetch(`/config/${configFileName}`);
        const dataConfig = await response.json();
        setConfig(dataConfig);
        console.info(`VERSION: ${dataConfig.VERSION}`);
      } catch (error) {
        console.error('Error in initializing');
        setIsHavingSetupErr(true);
      }
    };
    getConfigFile();
  }, []);

  return { config, isHavingSetupErr };
}
